import {
  CheckCircle,
  XCircle,
  Info,
  AlertTriangle,
  X
} from "lucide-react";

import "./toast.css";

const icons = {
  success: CheckCircle,
  error: XCircle,
  info: Info,
  warning: AlertTriangle
};

export default function Toast({ toast, onClose }) {

  const Icon = icons[toast.type] || Info;

  return (
    <div className={`toast toast-${toast.type}`}>

      <div className="toastIconWrapper">
        <Icon size={20}/>
      </div>

      <div className="toastContent">
        <div className="toastMessage">
          {toast.message}
        </div>

        <div
          className="toastProgress"
          style={{
            animationDuration: `${toast.duration}ms`
          }}
        />
      </div>

      <button
        className="toastClose"
        onClick={() => onClose(toast.id)}
      >
        <X size={16}/>
      </button>


    </div>
  );
}